import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { API_URL } from '../../../@jumbo/constants/AppConstants'; // ASSICURATI CHE QUESTO PERCORSO SIA CORRETTO
import PageContainer from '../../../@jumbo/components/PageComponents/layouts/PageContainer'; // Opzionale, per layout pagina standard
import IntlMessages from '../../../@jumbo/utils/IntlMessages'; // Opzionale, per internazionalizzazione
import { makeStyles } from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Typography,
  CircularProgress,
  Tooltip,
  Box, // Per spaziatura
} from '@material-ui/core';
// Importa Pagination da @material-ui/lab (per MUI v4)
// Se usi MUI v5+, l'import sarebbe: import Pagination from '@mui/material/Pagination';
import Pagination from '@material-ui/lab/Pagination';

import { MdDeleteForever } from 'react-icons/md';
import moment from 'moment'; // Assicurati che moment sia installato: npm install moment
import cogoToast from 'cogo-toast'; // Assicurati che cogo-toast sia installato: npm install cogo-toast

// Stili Material-UI
const useStyles = makeStyles(theme => ({
  tableContainer: {
    marginTop: theme.spacing(3),
    // maxHeight: '70vh', // Rimosso per permettere alla tabella di espandersi, la paginazione limita i dati
  },
  tableHeaderCell: {
    fontWeight: 'bold',
    backgroundColor: theme.palette.primary.main, // Usa colori dal tuo tema
    color: theme.palette.common.white,
  },
  noteCell: {
    maxWidth: 350, // Aumentata leggermente la larghezza massima
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  oidCell: {
    // Stile per la cella OID (opzionale)
    minWidth: '80px',
    textAlign: 'center',
  },
  actionCell: {
    // Stile per la cella Azioni
    width: '80px',
    textAlign: 'right',
  },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(3, 0), // Aggiunge più spazio verticale
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(5), // Aumentato padding per loading iniziale
  },
  tableRowLoading: {
    // Stile per la riga di caricamento nella tabella
    height: 53, // Altezza approssimativa di una riga
    textAlign: 'center',
  },
  linkStyle: {
    // Stile per rimuovere la decorazione del link
    textDecoration: 'none',
    color: theme.palette.primary.main, // Usa colore primario del tema per il link
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

// Breadcrumbs specifici per questa pagina (opzionale)
const breadcrumbs = [
  { label: <IntlMessages id={'sidebar.main'} />, link: '/' }, // Adatta l'ID se necessario
  { label: 'Tutti i Promemoria', isActive: true },
];

// Componente Principale
function TuttiPromemoria() {
  const classes = useStyles();
  const [listaTuttiPromemoria, setListaTuttiPromemoria] = useState([]);
  const [loading, setLoading] = useState(true); // Inizia come true

  // Stati per la paginazione
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(15); // Imposta quanti elementi vuoi per pagina
  const [totalItems, setTotalItems] = useState(0);

  // Funzione per caricare i promemoria paginati
  const fetchTuttiPromemoria = useCallback(
    (pageToFetch = 1) => {
      setLoading(true);
      fetch(`${API_URL}/getTuttiPromemoria.php?page=${pageToFetch}&limit=${itemsPerPage}`)
        .then(response => {
          if (!response.ok) {
            return response
              .json()
              .catch(() => ({}))
              .then(err => {
                throw new Error(err.message || `HTTP error! status: ${response.status}`);
              });
          }
          return response.json();
        })
        .then(risp => {
          // console.log("Risposta GetTuttiPromemoria:", risp); // Utile per debug
          if (risp.success && Array.isArray(risp.promemoria) && typeof risp.totalItems === 'number') {
            setListaTuttiPromemoria(risp.promemoria);
            setTotalItems(risp.totalItems);
            setCurrentPage(pageToFetch); // Sincronizza lo stato della pagina
          } else {
            setListaTuttiPromemoria([]);
            setTotalItems(0);
            cogoToast.error('Errore nel recuperare i dati: ' + (risp.message || 'Formato risposta non valido.'));
          }
        })
        .catch(error => {
          console.error('Errore nel caricamento promemoria:', error);
          setListaTuttiPromemoria([]);
          setTotalItems(0);
          cogoToast.error(`Errore di rete o del server: ${error.message}`);
        })
        .finally(() => {
          setLoading(false); // Nascondi loading alla fine, sia successo che errore
        });
    },
    [itemsPerPage],
  ); // La dipendenza è itemsPerPage (se lo rendi dinamico)

  // Funzione per eliminare un promemoria
  const handleEliminaPromemoria = promemoriaIdToDelete => {
    if (!promemoriaIdToDelete) {
      cogoToast.error('ID Promemoria non valido.');
      return;
    }
    if (window.confirm('Sei sicuro di voler eliminare questo promemoria?')) {
      // Non impostiamo loading qui, lo farà la fetch successiva

      fetch(API_URL + '/eliminaPromemoriaOrdine.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: promemoriaIdToDelete }),
      })
        .then(response => {
          if (!response.ok) {
            return response
              .json()
              .catch(() => ({}))
              .then(err => {
                throw new Error(err.message || `Errore HTTP: ${response.status}`);
              });
          }
          return response.json();
        })
        .then(risp => {
          if (risp.success) {
            cogoToast.success('Promemoria eliminato!');
            // Ricarica la pagina corretta dopo l'eliminazione
            const newTotalItems = totalItems - 1; // Aggiorna il totale PRIMA del calcolo
            const totalPagesAfterDelete = Math.ceil(newTotalItems / itemsPerPage);
            let pageToLoad = currentPage;

            // Se la pagina corrente diventa > del totale pagine dopo l'eliminazione, vai all'ultima pagina valida
            if (currentPage > totalPagesAfterDelete && totalPagesAfterDelete > 0) {
              pageToLoad = totalPagesAfterDelete;
            }
            // Se l'ultima pagina è diventata vuota (ma non era la prima), vai alla pagina precedente
            if (listaTuttiPromemoria.length === 1 && pageToLoad > 1 && newTotalItems > 0) {
              pageToLoad = currentPage - 1;
            }
            // Se stiamo già caricando la pagina corretta, forziamo comunque il refresh
            // Se invece dobbiamo cambiare pagina, l'useEffect si attiverà
            if (pageToLoad === currentPage) {
              fetchTuttiPromemoria(currentPage); // Ricarica la stessa pagina
            } else {
              setCurrentPage(pageToLoad); // Cambia pagina, l'useEffect farà la fetch
            }
          } else {
            cogoToast.error("Errore durante l'eliminazione: " + (risp.message || 'Errore sconosciuto'));
          }
        })
        .catch(error => {
          console.error("Errore nell'eliminazione:", error);
          cogoToast.error(`Errore di rete o del server durante l'eliminazione: ${error.message}`);
        });
    }
  };

  // Effetto per caricare i dati al mount e al cambio di pagina
  useEffect(() => {
    fetchTuttiPromemoria(currentPage);
  }, [currentPage, fetchTuttiPromemoria]); // Esegui quando cambia currentPage o la funzione fetch

  // Gestore per il cambio pagina della paginazione
  const handlePageChange = (event, value) => {
    if (value !== currentPage) {
      setCurrentPage(value); // Aggiorna lo stato, useEffect farà il resto
      // Opzionale: scrolla in cima alla pagina
      window.scrollTo(0, 0);
    }
  };

  // Calcola il numero totale di pagine
  const pageCount = Math.ceil(totalItems / itemsPerPage);

  // --- Render del componente ---
  return (
    // Usa PageContainer se fa parte del tuo layout standard
    <PageContainer heading="Promemoria Conferme ordini" breadcrumbs={breadcrumbs}>
      <Typography variant="body1" gutterBottom>
        Elenco di tutti i promemoria registrati ({loading ? 'caricamento...' : `${totalItems} totali`}).
      </Typography>

      {/* Indicatore di caricamento iniziale */}
      {loading && listaTuttiPromemoria.length === 0 && (
        <div className={classes.loadingContainer}>
          <CircularProgress />
        </div>
      )}

      {/* Contenitore Tabella (mostrato se non è il loading iniziale) */}
      {(!loading || listaTuttiPromemoria.length > 0) && (
        <TableContainer component={Paper} className={classes.tableContainer}>
          <Table stickyHeader aria-label="tabella tutti promemoria">
            <TableHead>
              <TableRow>
                <TableCell className={classes.tableHeaderCell}>Data</TableCell>
                <TableCell className={`${classes.tableHeaderCell} ${classes.oidCell}`}>OID Ordine</TableCell>{' '}
                <TableCell className={classes.tableHeaderCell}>Nota</TableCell>
                <TableCell align="right" className={classes.tableHeaderCell}>
                  Azioni
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* Indicatore di caricamento durante il cambio pagina */}
              {loading && (
                <TableRow>
                  <TableCell colSpan={3} className={classes.tableRowLoading}>
                    <CircularProgress size={24} />
                  </TableCell>
                </TableRow>
              )}
              {/* Righe dati (mostrate solo se non sta caricando) */}
              {!loading && listaTuttiPromemoria.length > 0 ? (
                listaTuttiPromemoria.map(prom => (
                  <TableRow key={prom.id} hover>
                    <TableCell component="th" scope="row" style={{ width: '120px' }}>
                      {' '}
                      {/* Larghezza fissa per data */}
                      {moment(prom.data).format('DD/MM/YYYY')}
                    </TableCell>
                    <TableCell className={classes.oidCell}>
                      <Link to={`/ordine/${prom.oid}`} className={classes.linkStyle}>
                        {' '}
                        {/* ADATTA IL PERCORSO `/ordine/` SE NECESSARIO */}
                        {prom.oid}
                      </Link>
                    </TableCell>
                    <TableCell className={classes.noteCell} title={prom.nota}>
                      {/* Potresti aggiungere un link all'ordine: <Link to={`/ordine/${prom.oid}`}>{prom.nota}</Link> */}
                      {prom.nota}
                    </TableCell>
                    <TableCell align="right" style={{ width: '80px' }}>
                      {' '}
                      {/* Larghezza fissa per azioni */}
                      <Tooltip title="Elimina promemoria">
                        <span>
                          {' '}
                          {/* Wrapper per tooltip su elemento disabilitato */}
                          <IconButton
                            size="small"
                            onClick={() => handleEliminaPromemoria(prom.id)}
                            style={{ color: 'red' }}
                            disabled={loading} // Disabilita durante il caricamento
                          >
                            <MdDeleteForever />
                          </IconButton>
                        </span>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))
              ) : !loading ? ( // Messaggio "Nessun promemoria" solo se caricamento finito e lista vuota
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    Nessun promemoria trovato.
                  </TableCell>
                </TableRow>
              ) : null /* Non mostrare nulla se sta caricando e la lista è vuota */}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {/* Componente Paginazione */}
      {/* Mostra solo se ci sono più pagine e il caricamento iniziale è finito */}
      {!loading && totalItems > 0 && pageCount > 1 && (
        <Box className={classes.paginationContainer}>
          <Pagination
            count={pageCount}
            page={currentPage}
            onChange={handlePageChange}
            color="primary"
            disabled={loading} // Disabilita anche qui per sicurezza
          />
        </Box>
      )}
    </PageContainer>
  );
}

export default TuttiPromemoria;
